<!-- eslint-disable-next-line agentic/no-single-template-wrapper -->
<div class="content flex h-full w-full flex-row items-center gap-3">
    <div
        [class]="iconClasses()"
        [style.--qpx-filter-card-icon-active-color]="iconActiveColor()"
    >
        <ng-icon
            qpx
            [context]="iconContext()"
            [class.text-primary-muted]="context() === 'accent'"
            [name]="icon()"
            [size]="isCompact() ? 'sm' : 'md'"
        />
    </div>
    <span
        class="title min-w-0 flex-1 line-clamp-2 break-words text-left text-body @5xs:text-body-lg font-semibold text-foreground"
        >{{ title() }}</span
    >
    <div class="subtitle">
        <ng-content />
    </div>
</div>
